$shm_showcase_group $mol_list
	rows /
		<= Label $mol_text
			text <= title
		<= Content $mol_view
			sub <= content /$mol_view
